import BoxWithShadow from "../../common/components/BoxWithShadow";
import Editor from "../../common/components/Editor";
import { SharedCompanyInfoSectionProps } from "../container/CompanyInfoContainer";

export default function PaymentInformation({
  form,
  onChange,
}: SharedCompanyInfoSectionProps) {
  return (
    <BoxWithShadow>
      <div className="flex h-full flex-col gap-24 overflow-y-auto">
        <div className="flex min-h-[500px] flex-col gap-1">
          <p className="text-lg font-bold">주의사항/환불안내</p>
          <Editor
            height="100%"
            value={form.paymentWarning}
            onChange={(value) => onChange("paymentWarning", value)}
          />
        </div>
        <div className="flex min-h-[500px] flex-col gap-1">
          <p className="text-lg font-bold">개인정보 제3자 제공</p>
          <Editor
            height="100%"
            value={form.paymentInformation}
            onChange={(value) => onChange("paymentInformation", value)}
          />
        </div>
      </div>
    </BoxWithShadow>
  );
}
